import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import '../../styles/deleteConfirmModal.css';

/**
 * Confirmation dialog before destructive removal; matches dashboard / automation modal styling.
 */
const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  warningText,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  isLoading = false,
}) => {
  return (
    <Modal isVisible={isOpen} onClose={onClose}>
      <div className="delete-confirmation-modal">
        <h3>{title}</h3>
        <p>{message}</p>
        {warningText ? (
          <p className="warning-text">{warningText}</p>
        ) : null}
        <div className="modal-actions">
          <button
            type="button"
            className="cancel-btn"
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="delete-btn"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? `${confirmLabel}…` : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

DeleteConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  warningText: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default DeleteConfirmModal;
